import React from "react";
import "./Send.css";
import PageHeader from "../../../components/headers/PageHeader";
import wave from "../../../assets/Images/waves/wave_mou.png";

export default function SEND() {
    return (
        <div className="send-page">
            <PageHeader
                mediaSrc={wave}
                mediaType="image"
                subtitle="Enhance Clinical Insight"
                title="Standard for Exchange of Nonclinical Data (SEND) Submission"
            />

            <section className="send-section send-introSection">
                <h2>Driving Confidence in Every Phase</h2>
                <p>
                    Accelerate your path to regulatory acceptance with Eupraxia’s
                    end-to-end SEND and nonclinical data services. From raw study data
                    to validated, submission-ready SEND packages — with precision,
                    compliance, and collaboration built in.
                </p>
            </section>

            <section className="send-section send-cardSection">
                <h2>Our SEND Capabilities</h2>

                <div className="send-cardGrid">
                    <article className="send-card">
                        <h3>Our SEND &amp; Nonclinical Data Services</h3>
                        <ul className="send-list">
                            <li>Source data acquisition, transformation, and normalization.</li>
                            <li>Mapping and conversion to SEND format including define.xml and SDRG.</li>
                            <li>Legacy study data migration, warehousing, and reprocessing.</li>
                            <li>Metadata management, controlled terminology alignment, and versioning.</li>
                            <li>Automated and manual quality control, conformance checking, and validation.</li>
                            <li>Regulatory packaging, submission-ready package assembly, and authority query support.</li>
                            <li>Ongoing SEND support: amendments, updates, and cross-study integration.</li>
                            <li>Consultancy and training for in-house SEND adoption.</li>
                        </ul>
                    </article>

                    <article className="send-card">
                        <h3>Why Eupraxia Stands Out</h3>
                        <ul className="send-list">
                            <li>Deep SEND domain expertise aligned with SENDIG v3.x, SENDIG-Genetox, and evolving standards.</li>
                            <li>Agile, globally informed team based in India with strategic cost advantage and rigorous quality.</li>
                            <li>Seamless collaboration across CROs, labs, biostatisticians, and sponsors.</li>
                            <li>Modern toolchain using internal validators with Pinnacle21, OpenCDISC, and related platforms.</li>
                            <li>Flexible engagement: full outsourcing, study-by-study support, or team augmentation.</li>
                            <li>Transparent project governance with milestone tracking and audit-ready documentation.</li>
                            <li>Fast turnaround for complex multi-source datasets.</li>
                            <li>Compliance assurance through traceability, audit trails, and version control.</li>
                        </ul>
                    </article>

                    <article className="send-card">
                        <h3>Project Activities &amp; Deliverables</h3>
                        <ul className="send-list">
                            <li>SEND readiness audits and gap assessments.</li>
                            <li>Study-level source-to-SEND mapping including domain mapping and metadata specifications.</li>
                            <li>Define.xml, SDRG / nSDRG creation and validation.</li>
                            <li>Dataset quality control, error resolution, and reconciliation.</li>
                            <li>Generation of fully packaged submission sets with data, define.xml, and documentation.</li>
                            <li>Post-submission support including deficiency responses and dataset amendments.</li>
                            <li>Legacy data repurposing by converting historical studies to SEND format.</li>
                            <li>Cross-study harmonization and pooled dataset support.</li>
                            <li>Integration of Regulatory, Biostatistics, and SEND deliverables.</li>
                        </ul>
                    </article>
                </div>
            </section>

            <section className="send-section send-studyTypeSection">
                <h2>Preclinical Study Types Supported</h2>

                <p className="send-sectionIntro">
                    We provide end-to-end SEND solutions to the following preclinical
                    study types:
                </p>

                <div className="send-studyTypeGrid">
                    <article className="send-studyTypeCard">
                        Single-Dose Toxicity Studies
                    </article>

                    <article className="send-studyTypeCard">
                        Repeat-Dose Toxicity Studies
                    </article>

                    <article className="send-studyTypeCard">
                        Safety Pharmacology Studies
                    </article>

                    <article className="send-studyTypeCard">
                        Carcinogenicity Studies
                    </article>

                    <article className="send-studyTypeCard">
                        Developmental and Reproductive Toxicology — DART
                    </article>

                    <article className="send-studyTypeCard">
                        Toxicokinetic Studies
                    </article>

                    <article className="send-studyTypeCard">
                        Juvenile Toxicity Studies
                    </article>

                    <article className="send-studyTypeCard">
                        Specialized Nonclinical Studies
                    </article>
                </div>
            </section>
        </div>
    );
}